<!--
 * @Date: 2022-04-12 23:26:16
 * @LastEditTime: 2022-04-15 14:02:04
 * @Description: 购买成功
 * @FilePath: /vue-medweb/packages/vue-m-comprehensive/src/views/PaySuccess/index.vue
-->
<template>
  <div class="pay-success-wrap">
    <img
      class="success-icon"
      src="https://resource.chunyu.mobi/@/media/images/2022/04/13/86e9/444b666be9c2_w240_h240_.png"
      alt=""
    />
    <div class="success-tip">您已购买成功</div>
    <div class="tip">
      平台稍后将为您致电接通医生电话，号码为<span>{{ callNumber }}</span
      >，请您耐心等待，保持电话畅通。
    </div>
  </div>
</template>

<script>
export default {
  name: 'PaySuccess',
  data() {
    return {
      callNumber: this.$route.query.call_number,
    };
  },
};
</script>

<style lang="scss" scoped>
@import '@@/styles/mixin.scss';
.pay-success-wrap {
  padding: rem(60) rem(30) 0;
  font-weight: bold;
  .success-icon {
    display: block;
    width: rem(80);
    height: rem(80);
    margin: 0 auto rem(30);
  }
  .success-tip {
    font-size: rem(18);
  }
  .tip {
    margin-top: rem(20);
    color: #999;
    line-height: 1.4;
    text-align: left;
    span {
      color: #fe7f36;
    }
  }
}
</style>
